import {
	FETCH_INTERVIEW_QUESTIONS_SUCCESS,
	FETCH_INTERVIEW_QUESTION_BY_ID_SUCCESS,
	INTERVIEW_QUESTIONS_REQUEST_LOADING,
	INTERVIEW_QUESTIONS_REQUEST_ERRORS
} from "api/menu/hr/interview-questions/actions";

const initialState = {
	loading: false,
	errors: [],
	questions: [],
	singleQuestion: {}
};

export default function(state = initialState, action) {
	switch (action.type) {
		case INTERVIEW_QUESTIONS_REQUEST_LOADING:
			return { ...state, loading: true };
		case INTERVIEW_QUESTIONS_REQUEST_ERRORS:
			return { ...state, loading: false, errors: action.payload };
		case FETCH_INTERVIEW_QUESTIONS_SUCCESS:
			return { ...state, loading: false, questions: action.payload };
		case FETCH_INTERVIEW_QUESTION_BY_ID_SUCCESS:
			return { ...state, loading: false, singleQuestion: action.payload };
		default:
			return state;
	}
}
